import React from "react";
import { Branding,DisabledPrompt, Link } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";

import "./styles.css";

/**
 * @function SettingsMenuPage
 * @return {React.Component}
 * @exported true
 * @description The main component for SettingsMenuPage
 */
export default function SettingsMenuPage(props) {
    return (
        <PageContainer className="settings-menu-page">
            <PageContentView>
                <CenterContentContainer>
                    <ContentHeaderView text="Menu" />
                    <div className="flex-container flex-vertical">
                        <div className="flex-height link-item">
                            <Link to="/notifications">Alerts</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/authorizedApps">Authorized Apps</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/statementPreference">Paperless Preferences</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/authorizedDevicesWorkflow">Authorized Devices</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/settingsFastBalancesWorkflow">Fast Balances</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/textBanking">Text Banking</Link>
                        </div>
                        <Branding id="secure_forms_abi22" value="true" default="true">
                            <div className="flex-height link-item">
                                <Link to="/secureForms">Secure Forms</Link>
                            </div>
                        </Branding>
                        <div className="flex-height link-item">
                            <Link to="/userActivity">User Activity</Link>
                        </div>
                        <div className="flex-height link-item">
                            <Link to="/acceptedDisclosures">Accepted Disclosures</Link>
                        </div>
                        <div className="flex-height link-item">
                            <DisabledPrompt>
                                <Link>Delete an Account</Link>
                            </DisabledPrompt>
                        </div>
                    </div>
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
    )
}
